"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Illustration = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _illsData = _interopRequireDefault(require("./ills-data.json"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Local Json
// Style
var Illustration = function Illustration(_ref) {
  var type = _ref.type,
      style = _ref.style,
      size = _ref.size,
      className = _ref.className;

  function getIllsItem() {
    // Data merge
    var dataListObject = {};

    _illsData.default.category.map(function (listData) {
      dataListObject = Object.assign(dataListObject, listData.index);
      return null;
    });

    var objSrc = '';

    if (_illsData.default.dataList[dataListObject[type]] !== undefined) {
      objSrc = _illsData.default.dataList[dataListObject[type]].src;
    }

    return /*#__PURE__*/_react.default.createElement("img", {
      style: {
        width: "".concat(size)
      },
      src: objSrc,
      alt: ""
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "shpmtc-ills ".concat(className),
    style: style
  }, getIllsItem());
}; // Prop Types


exports.Illustration = Illustration;
Illustration.defaultProps = {
  type: undefined,
  style: null,
  size: '100%',
  className: ''
};
Illustration.propTypes = {
  type: _propTypes.default.string,
  style: _propTypes.default.instanceOf(Object),
  size: _propTypes.default.string,
  className: _propTypes.default.string
};